<script setup>
import {ref,computed} from 'vue'
import CategoriesComponent from './CategoriesComponent.vue'
import SelectInput from '../Forms/SelectInput.vue'
import useApi from '../../Services/useApi'
import { Inertia } from '@inertiajs/inertia'
import useNotification from '../../Services/useNotification'
const props = defineProps(['categories','fruit_id'])
const category_id = ref('')

const api = useApi()
const notificate = useNotification()

const add = () => {
    let values = {category_id:category_id.value,fruit_id:props.fruit_id}
    api.addFruitToCategory(values).then((res)=>{
        Inertia.reload()
    })
}
const remove = event => {
    notificate.confirm('Quieres eliminar esta categoria?',()=>{
        let values = {category_id:event,fruit_id:props.fruit_id}
        api.removeFruitToCategory(values).then((res)=>{
            Inertia.reload()
        })
    })
}
</script>

<template>
    <div class="">
        <CategoriesComponent :categories="categories" :editable='true' @remove='remove' />
        <SelectInput placeholder="Selecciona una categoria para añadirla" :items="$page.props.categories" v-model="category_id" @change="add"/>
    </div>
</template>